import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../components/modal/modal.component';
import {StyledFooter} from "../../components/pane/pane.style";
import Form from "../../components/form";
import {StyledModalContent} from "../../components/modal/modal.style";
import {disableSwipeToClose} from "../../utils/tools/modals";
import {Preferences} from "@capacitor/preferences";
import {useIonViewDidEnter} from "@ionic/react";
import {StyledWiteButton} from "@components/button/button.style";


type PropagationPhoneModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onReject: () => void;
    onSign: () => void;
};

const PropagationEmailSignModal: React.FC<PropagationPhoneModalProps> = (props: PropagationPhoneModalProps) => {

    const {t} = useTranslation();

    const [userEmail, setUserEmail] = useState<string|null>('');


    useEffect(() => {
        fetchUserData();
    }, []);

    useIonViewDidEnter(() => {
        fetchUserData();
    });

    const fetchUserData = async () => {
        let email = await Preferences.get({'key': 'email'});
        setUserEmail(email.value);
    }

    return (
        <>

            <Modal
                isOpen={props.isOpen}
                maxHeight={'95%'}
                canDismiss={disableSwipeToClose}
                disableClose={true}
                onDidDismiss={() => props.onClose()}>

                <StyledModalContent>
                    <h1 className="title">{t("propagation.email.title")}</h1>

                    <div className="content">
                        {t("propagation.email.text", {email: userEmail})}

                        <StyledFooter className="modal footer no-shadow">
                            <StyledWiteButton type="button" className="red"
                                         onClick={() => props.onReject()}>{t("propagation.rejectButton")}</StyledWiteButton>
                            <Form.Button onClick={() => props.onSign()}>{t("propagation.acceptButton")}</Form.Button>
                        </StyledFooter>
                    </div>

                </StyledModalContent>
            </Modal>
        </>
    );
};

export default PropagationEmailSignModal;